import React from 'react';
import './AlertDialog.css'; // We'll create this CSS file next

const AlertDialog = ({ isOpen, title, message, onClose, onConfirm, showOkButton = true }) => {
  if (!isOpen) return null;

  return (
    <div className="alert-dialog-overlay">
      <div className="alert-dialog-content">
        {title && <h2>{title}</h2>}
        <p>{message}</p>
        {showOkButton && (
          <div className="alert-dialog-actions">
            <button onClick={() => {
              if (onConfirm) {
                onConfirm();
              }
              onClose();
            }}>OK</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertDialog;